import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const DataTableColumnHeaders = ({ headerGroups }) => {
	if (headerGroups) {
		return headerGroups.map((headerGroup, index) => {
			// react-table's prop getters include a `key`; pull it out so it is
			// passed directly rather than spread into JSX (React warns on the
			// latter).
			const { key: headerGroupKey, ...headerGroupProps } =
				headerGroup.getHeaderGroupProps();
			return (
				<thead
					key={`hgroup-${index}`}
					style={{
						MozUserSelect: "none",
						WebkitUserSelect: "none",
						msUserSelect: "none",
					}}
				>
					<tr
						key={headerGroupKey ?? `tr-${index}`}
						{...headerGroupProps}
					>
						{headerGroup.headers.map((column, index2) => {
							const { key: headerKey, ...headerProps } =
								column.getHeaderProps(
									column.getSortByToggleProps()
								);
							return (
								<th
									scope="col"
									key={`col-${index}-${index2}`}
								>
									<div
										key={
											headerKey ??
											`colHeader-${index2}`
										}
										{...headerProps}
									>
										{column.render("Header")}
										{column.isSorted ? (
											<FontAwesomeIcon
												className="ms-1"
												icon={
													column.isSortedDesc
														? faArrowUp
														: faArrowDown
												}
											/>
										) : (
											""
										)}
									</div>
									<div key={`colFilter-${index2}`}>
										{column.canFilter &&
										column.isFilter !== false
											? column.render("Filter")
											: null}
									</div>
								</th>
							);
						})}
					</tr>
				</thead>
			);
		});
	}
	return null;
};
